import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { CurrentRouteService } from '../currentRoute.service';
import {AccountIdService, AccountNameService, AgencyIdService} from "../account.service";
import * as _ from "lodash";
import {DashboardApiService} from "./dashboard-api.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  agency_id:string;
  account_id:string;

  constructor(public router: Router,
              public route: ActivatedRoute,
              private currentrouteService: CurrentRouteService,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private accountnameService: AccountNameService,
              private dashboardApiService: DashboardApiService) { }


  ngOnInit(): void {
    console.log('from dashboard', this.router.url)

    //ANNOUCMENTS NEEDED ON EVERY COMPONENT TO INFORM MANIN NAVIGATION
    //OF THE AGENCY AND ACCOUNT ID AND NAME WE ARE ON TO GRACEFULLY RELOAD
    this.currentrouteService.announceCurrentRoute(this.router.url);
    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id']
      this.account_id = parms['account_id']
    });
    let query_parms = this.route.snapshot.queryParamMap;
    let account_name = query_parms.get('account_name');
    this.accountnameService.announceAccountName(account_name)
    this.accountidService.announceAccountId(this.account_id)
    this.agencyidService.announceAgencyId(this.agency_id)

    console.log('from dashboard', this.agency_id, this.account_id)

    //this.loadNotificatons(this.account_id)


  }  // end ngOnInit

  notification_data:any = [];
  loadNotificatons(account_id){

    let endpoint = `notifications/account/${account_id}`;
    let fu = this.dashboardApiService.get(endpoint).subscribe(x => {

      this.notification_data = x['body'];
      console.log('from dashboard notification data',this.notification_data)
      // this.notification_count = 0;
      // this.notification_data = [];
      // console.log('NOTOFICATION COUNT',this.notification_count)
      // if (_.isEmpty(x['body'])) {
      //   console.log('no notification data')
      //   this.notification_count = 0;
      // } else {
      //   console.log('proccess notification data')
      //   this.notification_data = x['body'];
      //   this.notification_count = this.notification_data.length
      // }

    }, error => {
      console.log('ERROR',error)
    }); //end apiService


  } //end loadNotificatons()






} //end component
